/**
 * Máscara BR `(47) 99919-0000` / `(47) 3333-1000` para o campo da página pública.
 * Só formatação de tela: o backend recebe `+{ddi}{dígitos}` cru e normaliza
 * (NUNCA #77 — nenhuma comparação de telefone acontece aqui).
 */
export const maskBrPhone = (raw: string): string => {
  const d = raw.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

/** `+55` + dígitos. DDI ≠ 55: sem máscara, só dígitos. */
export const phoneToE164Input = (ddi: string, value: string): string => {
  const code = ddi.replace(/\D/g, '') || '55';
  return `+${code}${value.replace(/\D/g, '')}`;
};

export const isPhoneComplete = (ddi: string, value: string): boolean => {
  const digits = value.replace(/\D/g, '');
  return ddi.replace(/\D/g, '') === '55' ? digits.length === 10 || digits.length === 11 : digits.length >= 8;
};
